import { RequestsHistoryView } from "@/features/request-history/components/RequestHistoryView"

export default function RequestsHistoryPage() {
  return <RequestsHistoryView />
}